import { createFileRoute, redirect } from '@tanstack/react-router'

import { ROLES } from '@/entities/auth'
import { IntegrationPage } from '@/pages/integration-page'

export const Route = createFileRoute('/_dashboard/integration')({
    onEnter: () => {
        document.title = 'Taxoparkee - API-интеграция'
    },
    beforeLoad: ({ context }) => {
        if (!context.auth.hasAnyRole([ROLES.superManager])) {
            throw redirect({
                to: '/recruitment',
                search: { page: 1 },
            })
        }
    },
    component: IntegrationPage,
})
